<template>
  <div>
    <v-row v-if="SELECTED_CLUSTER.length !== 0">
      <v-col cols="12">
        <v-data-table
          :headers="headersDTP"
          :items="SELECTED_CLUSTER.dtp_list"
          item-key="id_dtp"
          show-expand
          class="elevation-1"
        >
          <template v-slot:item.edit="{ item }">
            <v-btn small rounded color="primary" @click="editItem(item)"
              >Редактировать</v-btn
            >

            <v-dialog v-model="editModal" max-width="500px">
              <v-card>
                <v-card-title class="headline"
                  >ДТП №{{ item.id_dtp }}</v-card-title
                >

                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <h3>Сменить место концентрации</h3>
                      <v-text-field
                        label="Номер места концентрации"
                        v-model="clusterNumber"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        label="Удалить из места концентрации"
                        v-model="deleteCheckbox"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="saveChanges(item, clusterNumber)"
                    >Сохранить</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="closeModal"
                    >Отмена</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td>
              <v-list-item
                :colspan="headers.length"
                v-for="(row, index) in item"
                :key="index"
              >
                {{ index }}
                {{ row }}
              </v-list-item>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getAPI } from "../api/axios-base";
export default {
  data() {
    return {
      headersClusters: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "pk",
        },
        { text: "Местоположение", value: "location" },
        { text: "Статус", value: "status" },
        { text: "Кол-во ДТП", value: "dtp_amount" },
        { text: "", value: "button", sortable: false },
      ],
      headersDTP: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id_dtp",
        },
        { text: "Местоположение", value: "location" },
        { text: "Время", value: "date" },
        { text: "Тип ДТП", value: "type_dtp" },
        { text: "Место", value: "place" },
        { text: "", value: "edit" },
        { text: "", value: "data-table-expand" },
      ],
      isShowTableClusters: true,
      isShowTableDTPs: false,
      editModal: false,
      clusterNumber: "",
      deleteCheckbox: false,
    };
  },
  methods: {
    ...mapActions(["GET_CLUSTER", "GET_CLUSTERS"]),
    showCluster(id) {
      this.GET_CLUSTER(id);
      this.isShowTableClusters = false;
      this.isShowTableDTPs = true;
    },
    editItem() {
      this.editModal = true;
    },
    closeModal() {
      this.editModal = false;
    },
    saveChanges(item, newClusterId) {
      if (this.clusterNumber === "" && this.deleteCheckbox == true) {
        let newDTP = item;
        newDTP.cluster = "";
        let token = localStorage.getItem('access_token');
        getAPI
          .put(
            "/api/v1/dtpdetail/" + newDTP.id_dtp + "/",
            newDTP,
            { headers: {
              Authorization: `Bearer ${token}`
              },
            }
          )
          .then((response) => console.log(response));
      } else {
        let newDTP = item;
        newDTP.cluster = newClusterId;
        let token = localStorage.getItem('access_token');
        getAPI
          .put(
            "/api/v1/dtpdetail/" + newDTP.id_dtp + "/",
              newDTP,
              { headers: { Authorization: `Bearer ${token}` }},
          )
          .then((response) => console.log(response));
      }
      this.editModal = false;
    },
  },
  computed: {
    ...mapGetters(["SELECTED_CLUSTER"]),
    ...mapGetters(["CLUSTERS"]),
  },
  watch: {
    editModal(val) {
      val || this.closeModal();
    },
  },
};
</script>

<style></style>
